import $ from 'jquery';
import techHybridArticle2 from './tech-hybrid/article-2';

$(document).ready(() => {
  console.log('init tech article-2');
  techHybridArticle2();
});
